import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal"];

  modalTargetConnected() {
    const modal = new Modal(this.modalTarget);

    modal.show();

    this.modalTarget.addEventListener(
      "hidden.bs.modal",
      () => {
        this.modalTarget.remove();
      },
      { once: true }
    );
  }
}
